import { useContext } from "react";
import { TeamsContext } from "../context/context";

export const useTeamInfo = () => {
  const context = useContext(TeamsContext);
  return context;
};
